import type { MessageKey } from "../../i18n/en";

export interface PersonDraft {
  name: string;
  number: string;
}

export interface PersonErrors {
  name?: MessageKey;
  number?: MessageKey;
}

const MAX_NAME = 80;
const MAX_NUMBER = 999;

/** Client-side checks that mirror the API schema; the server stays the authority. */
export function validatePersonDraft(draft: PersonDraft): PersonErrors {
  const errors: PersonErrors = {};
  const name = draft.name.trim();
  if (name.length === 0 || name.length > MAX_NAME) {
    errors.name = "person.invalidName";
  }
  const number = draft.number.trim();
  if (number !== "" && !isValidNumber(number)) {
    errors.number = "person.invalidNumber";
  }
  return errors;
}

function isValidNumber(text: string): boolean {
  if (!/^\d+$/.test(text)) return false;
  const value = Number(text);
  return value >= 0 && value <= MAX_NUMBER;
}

/** Converts a validated draft into the API payload: empty number becomes null. */
export function draftToPayload(draft: PersonDraft): { name: string; number: number | null } {
  const number = draft.number.trim();
  return {
    name: draft.name.trim(),
    number: number === "" ? null : Number(number),
  };
}
